import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useGates() {
  return useQuery({
    queryKey: ['gates', 'list'],
    queryFn: async () => {
      const { data } = await api.get('/gates');
      return data?.gates || data?.data || data || [];
    },
    refetchInterval: 30000,
    staleTime: 5000
  });
}
